import { Fragment } from "react";

import MainNav from "./MainNav";
import Notifications from "../UI/Notifications";
import StarterChecklist from "../UI/StarterChecklist";
import { starterChecklistEnabled } from "../../utils/features";
import useNavigationEnabled from "../../hooks/useNavigationEnabled";
import { Toaster } from 'react-hot-toast';
import usePublicLocation from "../../hooks/usePublicLocation";

const Layout = (props: any) => {
  const navigationEnabled = useNavigationEnabled();
  const isPublicLocation = usePublicLocation();

  return (
    <Fragment>
      <Toaster />
      {!isPublicLocation && <MainNav />}
      <main>
        {navigationEnabled && <Notifications />}
        {navigationEnabled && starterChecklistEnabled && <StarterChecklist />}
        {props.children}
      </main>
    </Fragment>
  );
};

export default Layout;
